import * as React from 'react';
import { FC } from 'react';
import { useContext } from './useFormContext';
import { UpdateValidationState } from './useValidationState';
import Field from './Field';

type ProfileFieldsProps = {
  fields: string[];
  updateValidationState: UpdateValidationState;
};

const ProfileFields: FC<ProfileFieldsProps> = ({ fields, updateValidationState }) => {
  const { locales } = useContext();

  if (!fields.length) return null;

  return (
    <div className="rs-row">
      <div className="alert">
        <div className="rs-text-size_medium rs-text-align_center">{locales.profile_fields.set_fields}:</div>
        {fields.map((field) => (
          <div key={field} className="rs-column-small-12">
            {['first_name', 'last_name'].includes(field) && (
              <Field
                validation="html5"
                name={`profile_fields[${field}]`}
                label={locales.profile_fields[field]}
                required
                minLength={2}
                maxLength={30}
                updateValidationState={updateValidationState}
              />
            )}
            {['birthday'].includes(field) && (
              <Field
                type="date"
                validation="html5"
                name={`profile_fields[${field}]`}
                label={locales.profile_fields[field]}
                required
                updateValidationState={updateValidationState}
              />
            )}
            {['unconfirmed_phone_number'].includes(field) && (
              <Field
                validation="phoneWithCode"
                name={`profile_fields[${field}]`}
                label={locales.profile_fields[field]}
                required
                updateValidationState={updateValidationState}
              />
            )}
            {['zip'].includes(field) && (
              <Field
                validation="html5"
                name={`profile_fields[${field}]`}
                label={locales.profile_fields[field]}
                required
                minLength={2}
                maxLength={16}
                updateValidationState={updateValidationState}
              />
            )}
            {['region', 'city'].includes(field) && (
              <Field
                validation="html5"
                name={`profile_fields[${field}]`}
                label={locales.profile_fields[field]}
                required
                updateValidationState={updateValidationState}
              />
            )}
            {['address1'].includes(field) && (
              <Field
                validation="html5"
                name={`profile_fields[${field}]`}
                label={locales.profile_fields[field]}
                required
                minLength={2}
                maxLength={50}
                updateValidationState={updateValidationState}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileFields;
